





































































































































































































































import { Company, FinanceInfo } from '@/utils/Interfaces'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InputGeneric from '@/components/InputGeneric.vue'

@Component({
  components: {
    InputGeneric,
  }
})
export default class NhapLieuCtyTTTaiChinhInputs extends Vue {
  @Prop() readonly financeInfo!: FinanceInfo
  @Prop() readonly company!: Company

  @Watch('financeInfo.doanh_thu_cong_ich_ke_hoach')
  onDoanhThuCongIchKhChange (value: number | null) {
    this.financeInfo.doanh_thu_ke_hoach = (value || 0) + (this.financeInfo.doanh_thu_ngoai_cong_ich_ke_hoach || 0)
  }

  @Watch('financeInfo.doanh_thu_ngoai_cong_ich_ke_hoach')
  onDoanhThuNgoaiCongIchKhChange (value: number | null) {
    this.financeInfo.doanh_thu_ke_hoach = (value || 0) + (this.financeInfo.doanh_thu_cong_ich_ke_hoach || 0)
  }

  @Watch('financeInfo.doanh_thu_cong_ich_thuc_hien')
  onDoanhThuCongIchThChange (value: number | null) {
    this.financeInfo.doanh_thu_thuc_hien = (value || 0) + (this.financeInfo.doanh_thu_ngoai_cong_ich_thuc_hien || 0)
  }

  @Watch('financeInfo.doanh_thu_ngoai_cong_ich_thuc_hien')
  onDoanhThuNgoaiCongIchThChange (value: number | null) {
    this.financeInfo.doanh_thu_thuc_hien = (value || 0) + (this.financeInfo.doanh_thu_cong_ich_thuc_hien || 0)
  }

  @Watch('financeInfo.von_gop_CSH_dau_nam')
  onVonGcshDauNamChange (value: number | null) {
    this.financeInfo.von_gop_CSH_thuc_hien_dau_nam = (value || 0) + (this.financeInfo.quy_dtpt_dau_nam || 0)
  }

  @Watch('financeInfo.quy_dtpt_dau_nam')
  onQuyDTPTDauNamChange (value: number | null) {
    this.financeInfo.von_gop_CSH_thuc_hien_dau_nam = (value || 0) + (this.financeInfo.von_gop_CSH_dau_nam || 0)
  }

  @Watch('financeInfo.von_gop_CSH_cuoi_nam')
  onVonGcshCuoiNamChange (value: number | null) {
    this.financeInfo.von_gop_CSH_thuc_hien_cuoi_nam = (value || 0) + (this.financeInfo.quy_dtpt_cuoi_nam || 0)
  }

  @Watch('financeInfo.quy_dtpt_cuoi_nam')
  onQuyDTPTCuoiNamChange (value: number | null) {
    this.financeInfo.von_gop_CSH_thuc_hien_cuoi_nam = (value || 0) + (this.financeInfo.von_gop_CSH_cuoi_nam || 0)
  }

  @Watch('financeInfo.ty_le_co_tuc_ke_hoach_tong_cong_ty')
  onTyLeCoTucKhTctChange (value: number | null) {
    const von_dieu_le = this.company.von_dieu_le_tong_cong_ty
    if (
      value !== null &&
      von_dieu_le !== undefined &&
      von_dieu_le !== null &&
      von_dieu_le !== 0
    ) {
      this.financeInfo.co_tuc_ke_hoach_tong_cong_ty = value * von_dieu_le
    }
  }

  @Watch('financeInfo.ty_le_co_tuc_thuc_hien_tong_cong_ty')
  onTyLeCoTucThTctChange (value: number | null) {
    const von_dieu_le = this.company.von_dieu_le_tong_cong_ty
    if (
      value !== null &&
      von_dieu_le !== undefined &&
      von_dieu_le !== null &&
      von_dieu_le !== 0
    ) {
      this.financeInfo.co_tuc_thuc_hien_tong_cong_ty = value * von_dieu_le
    }
  }

  @Watch('financeInfo.ty_le_co_tuc_ke_hoach_don_vi')
  onTyLeCoTucKhDvChange (value: number | null) {
    const von_dieu_le = this.company.von_dieu_le_don_vi
    if (
      value !== null &&
      von_dieu_le !== undefined &&
      von_dieu_le !== null &&
      von_dieu_le !== 0
    ) {
      this.financeInfo.co_tuc_ke_hoach_don_vi = value * von_dieu_le
    }
  }

  @Watch('financeInfo.ty_le_co_tuc_thuc_hien_don_vi')
  onTyLeCoTucThDvChange (value: number | null) {
    const von_dieu_le = this.company.von_dieu_le_don_vi
    if (
      value !== null &&
      von_dieu_le !== undefined &&
      von_dieu_le !== null &&
      von_dieu_le !== 0
    ) {
      this.financeInfo.co_tuc_thuc_hien_don_vi = value * von_dieu_le
    }
  }
}
